import { CONSENT_LAYER } from './consentMetrics';

// Layer 2 is the settings page (privacy manager): from the "settings" button, the footer link or the URL.
let settingsPageOpen = false;

// For the "settings" button on layer 1: Sourcepoint opens the settings page itself.
export const markSettingsPageOpen = (): void => {
  settingsPageOpen = true;
};

export const openSettingsPage = (privacyManagerId?: number): void => {
  if (typeof window._sp_?.gdpr?.loadPrivacyManagerModal !== 'function') {
    return;
  }

  markSettingsPageOpen();
  if (privacyManagerId === undefined) {
    window._sp_.gdpr.loadPrivacyManagerModal();
  } else {
    window._sp_.gdpr.loadPrivacyManagerModal(privacyManagerId);
  }
};

export const currentLayer = (): CONSENT_LAYER => (settingsPageOpen ? CONSENT_LAYER.TWO : CONSENT_LAYER.ONE);
